import { CSSProp, styled, VariantProps } from '@streamelements/frontend-ui';
import { PropsWithChildren } from 'react';

type Props = CSSProp;

const Root = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '0.25rem',
});

function StepsIndicator({ css, children }: PropsWithChildren<Props>) {
  return <Root css={css}>{children}</Root>;
}

const StyledStep = styled('div', {
  size: '0.5rem',
  borderRadius: '0.25rem',
  transition: 'width 0.2s ease-in-out, background 0.2s ease-in-out',

  variants: {
    state: {
      active: {
        backgroundColor: '$uiPrimaryMain',
        width: '1.5rem',
      },
      inactive: {
        backgroundColor: '$textPrimary25',
      },
    },
  },

  defaultVariants: {
    state: 'inactive',
  },
});

function StepsIndicatorItem({ css, ...props }: VariantProps<typeof StyledStep> & CSSProp) {
  return <StyledStep css={css} {...props} />;
}

export { StepsIndicator as StepsIndicatorRoot, StepsIndicatorItem };
